import { useState, useEffect } from 'react'
import { getTemporadas } from '../../../lib/supabase'

const rank = (t) => (t.estado === 'abierta' ? 0 : t.estado === 'planeada' ? 1 : 2)

// `preferidaId` (opcional): temporada que gana sobre la abierta si existe en la
// lista. La usa quien llega con la temporada en la URL -- p.ej. "Asignar" desde
// Planes, que ademas manda el plan: sin esto la pantalla montaba siempre en la
// temporada abierta y soltaba el plan por no ser de ahi, dejando al admin sin
// la unica puerta de entrada que le queda desde Planes.
export const useTemporadaActiva = (preferidaId = null) => {
  const [temporadas, setTemporadas] = useState([])
  const [temporadaId, setTemporadaId] = useState(null)

  useEffect(() => {
    const load = async () => {
      const { data } = await getTemporadas(false) // todas; ordenamos por estado
      const sorted = (data || []).sort((a, b) => {
        const r = rank(a) - rank(b)
        if (r !== 0) return r
        return new Date(b.fecha_inicio) - new Date(a.fecha_inicio)
      })
      setTemporadas(sorted)
      const preferida = preferidaId && sorted.find((t) => t.id === preferidaId)
      const abierta = sorted.find((t) => t.estado === 'abierta')
      if (preferida) setTemporadaId(preferida.id)
      else if (abierta) setTemporadaId(abierta.id)
      else if (sorted.length) setTemporadaId(sorted[0].id)
    }
    load()
  }, [preferidaId])

  return { temporadaId, setTemporadaId, temporadas }
}
